export const guidelinesTranslations = {
  fr: {
    title: "Guidelines & Actualités",
    hero: {
      title: "Restez à jour",
      description: "Suivez les dernières recommandations et actualités médicales personnalisées selon votre spécialité",
      stats: "Mises à jour quotidiennes",
      unread: "non lues",
      feeds: "flux",
      active: "Actif"
    },
    tabs: {
      notifications: "Notifications",
      settings: "Paramètres"
    },
    filters: {
      all: "Tous",
      unread: "Non lus",
      read: "Lus",
      allSpecialties: "Toutes",
      noResults: "Aucun résultat",
      noResultsDescription: "Aucune notification ne correspond aux filtres sélectionnés",
      reset: "Réinitialiser les filtres",
      searchNotifications: "Rechercher dans les notifications...",
      searchFeeds: "Rechercher un flux...",
      subscribed: "Abonnés",
      available: "Disponibles",
      noFeedResults: "Essayez avec d'autres critères de recherche",
      resetFilters: "Réinitialiser"
    },
    notifications: {
      title: "Vos notifications",
      markAllRead: "Tout marquer comme lu",
      empty: "Aucune notification",
      emptyDescription: "Abonnez-vous à des flux RSS pour recevoir des notifications personnalisées",
      buttonSubscribe: "Gérer les abonnements",
      new: "Nouveau",
      readArticle: "Lire l'article",
      markRead: "Marquer comme lu",
      markReadSwipe: "Marquer lu",
      share: "Partager",
      addToFavorites: "Ajouter aux favoris",
      addedToFavorites: "Article ajouté aux favoris",
      removedFromFavorites: "Article retiré des favoris",
      favoritesError: "Impossible d'ajouter aux favoris",
      linkCopied: "Lien copié dans le presse-papiers",
      showMore: "Voir plus",
      showLess: "Voir moins",
      swipeHint: "← Glissez pour marquer comme lu",
      newNotification: "Nouvelle notification",
      dataRefreshed: "Données actualisées",
      refresh: "Actualiser",
      scrollToTop: "Retour en haut",
      loadMore: "Charger plus",
      loadingMore: "Chargement..."
    },
    settings: {
      title: "Abonnements aux flux RSS",
      description: "Choisissez les sources d'actualités médicales qui vous intéressent",
      frequency: "Fréquence",
      subscribed: "Abonné",
      notSubscribed: "Non abonné",
      subscribedCount: "{{count}}/{{total}} abonnés",
      subscribeAll: "S'abonner à tous",
      unsubscribeAll: "Se désabonner de tous",
      frequencies: {
        weekly: "Hebdomadaire",
        biweekly: "Bi-hebdomadaire",
        monthly: "Mensuelle"
      },
      lastUpdate: "Dernière mise à jour",
      empty: "Aucun flux disponible",
      emptyDescription: "Les flux RSS seront bientôt disponibles"
    },
    dateGroups: {
      today: "Aujourd'hui",
      yesterday: "Hier",
      thisWeek: "Cette semaine",
      thisMonth: "Ce mois",
      older: "Plus ancien"
    },
    relative: {
      justNow: "À l'instant",
      minutesAgo: "Il y a {{count}}min",
      hoursAgo: "Il y a {{count}}h",
      daysAgo: "Il y a {{count}}j"
    },
    specialties: {
      urgence: "Médecine d'urgence",
      urgences: "Urgences",
      anesthesie: "Anesthésie-Réanimation",
      anesthesie_reanimation: "Anesthésie-Réanimation",
      medecine_interne: "Médecine interne",
      general: "Médecine générale",
      medecine_generale: "Médecine générale",
      cardiologie: "Cardiologie",
      neurologie: "Neurologie",
      pneumologie: "Pneumologie",
      gastroenterologie: "Gastro-entérologie",
      pediatrie: "Pédiatrie",
      radiologie: "Radiologie"
    },
    messages: {
      subscribed: "Abonné au flux",
      unsubscribed: "Désabonné du flux",
      frequencyUpdated: "Fréquence mise à jour",
      allMarkedRead: "Toutes les notifications marquées comme lues",
      loadError: "Erreur lors du chargement des données",
      updateError: "Erreur lors de la mise à jour",
      loading: "Chargement..."
    }
  },
  en: {
    title: "Guidelines & News",
    hero: {
      title: "Stay updated",
      description: "Follow the latest medical recommendations and news personalized to your specialty",
      stats: "Daily updates",
      unread: "unread",
      feeds: "feeds",
      active: "Active"
    },
    tabs: {
      notifications: "Notifications",
      settings: "Settings"
    },
    filters: {
      all: "All",
      unread: "Unread",
      read: "Read",
      allSpecialties: "All",
      noResults: "No results",
      noResultsDescription: "No notifications match the selected filters",
      reset: "Reset filters",
      searchNotifications: "Search notifications...",
      searchFeeds: "Search feeds...",
      subscribed: "Subscribed",
      available: "Available",
      noFeedResults: "Try with different search criteria",
      resetFilters: "Reset"
    },
    notifications: {
      title: "Your notifications",
      markAllRead: "Mark all as read",
      empty: "No notifications",
      emptyDescription: "Subscribe to RSS feeds to receive personalized notifications",
      buttonSubscribe: "Manage subscriptions",
      new: "New",
      readArticle: "Read article",
      markRead: "Mark as read",
      markReadSwipe: "Mark read",
      share: "Share",
      addToFavorites: "Add to favorites",
      addedToFavorites: "Article added to favorites",
      removedFromFavorites: "Article removed from favorites",
      favoritesError: "Unable to add to favorites",
      linkCopied: "Link copied to clipboard",
      showMore: "Show more",
      showLess: "Show less",
      swipeHint: "← Swipe to mark as read",
      newNotification: "New notification",
      dataRefreshed: "Data refreshed",
      refresh: "Refresh",
      scrollToTop: "Back to top",
      loadMore: "Load more",
      loadingMore: "Loading..."
    },
    settings: {
      title: "RSS feed subscriptions",
      description: "Choose the medical news sources that interest you",
      frequency: "Frequency",
      subscribed: "Subscribed",
      notSubscribed: "Not subscribed",
      subscribedCount: "{{count}}/{{total}} subscribed",
      subscribeAll: "Subscribe all",
      unsubscribeAll: "Unsubscribe all",
      frequencies: {
        weekly: "Weekly",
        biweekly: "Bi-weekly",
        monthly: "Monthly"
      },
      lastUpdate: "Last update",
      empty: "No feeds available",
      emptyDescription: "RSS feeds will be available soon"
    },
    dateGroups: {
      today: "Today",
      yesterday: "Yesterday",
      thisWeek: "This week",
      thisMonth: "This month",
      older: "Older"
    },
    relative: {
      justNow: "Just now",
      minutesAgo: "{{count}}min ago",
      hoursAgo: "{{count}}h ago",
      daysAgo: "{{count}}d ago"
    },
    specialties: {
      urgence: "Emergency Medicine",
      urgences: "Emergency Medicine",
      anesthesie: "Anesthesiology",
      anesthesie_reanimation: "Anesthesiology & Critical Care",
      medecine_interne: "Internal Medicine",
      general: "General Medicine",
      medecine_generale: "General Medicine",
      cardiologie: "Cardiology",
      neurologie: "Neurology",
      pneumologie: "Pulmonology",
      gastroenterologie: "Gastroenterology",
      pediatrie: "Pediatrics",
      radiologie: "Radiology"
    },
    messages: {
      subscribed: "Subscribed to feed",
      unsubscribed: "Unsubscribed from feed",
      frequencyUpdated: "Frequency updated",
      allMarkedRead: "All notifications marked as read",
      loadError: "Error loading data",
      updateError: "Error updating",
      loading: "Loading..."
    }
  },
  es: {
    title: "Guías y Noticias",
    hero: {
      title: "Manténgase actualizado",
      description: "Siga las últimas recomendaciones y noticias médicas personalizadas según su especialidad",
      stats: "Actualizaciones diarias",
      unread: "no leídas",
      feeds: "fuentes",
      active: "Activo"
    },
    tabs: {
      notifications: "Notificaciones",
      settings: "Configuración"
    },
    filters: {
      all: "Todos",
      unread: "No leídos",
      read: "Leídos",
      allSpecialties: "Todas",
      noResults: "Sin resultados",
      noResultsDescription: "Ninguna notificación coincide con los filtros seleccionados",
      reset: "Restablecer filtros",
      searchNotifications: "Buscar en notificaciones...",
      searchFeeds: "Buscar una fuente...",
      subscribed: "Suscritos",
      available: "Disponibles",
      noFeedResults: "Intente con otros criterios de búsqueda",
      resetFilters: "Restablecer"
    },
    notifications: {
      title: "Sus notificaciones",
      markAllRead: "Marcar todo como leído",
      empty: "Sin notificaciones",
      emptyDescription: "Suscríbase a fuentes RSS para recibir notificaciones personalizadas",
      buttonSubscribe: "Gestionar suscripciones",
      new: "Nuevo",
      readArticle: "Leer artículo",
      markRead: "Marcar como leído",
      markReadSwipe: "Marcar leído",
      share: "Compartir",
      addToFavorites: "Añadir a favoritos",
      addedToFavorites: "Artículo añadido a favoritos",
      removedFromFavorites: "Artículo eliminado de favoritos",
      favoritesError: "No se pudo añadir a favoritos",
      linkCopied: "Enlace copiado al portapapeles",
      showMore: "Ver más",
      showLess: "Ver menos",
      swipeHint: "← Deslice para marcar como leído",
      newNotification: "Nueva notificación",
      dataRefreshed: "Datos actualizados",
      refresh: "Actualizar",
      scrollToTop: "Volver arriba",
      loadMore: "Cargar más",
      loadingMore: "Cargando..."
    },
    settings: {
      title: "Suscripciones a fuentes RSS",
      description: "Elija las fuentes de noticias médicas que le interesan",
      frequency: "Frecuencia",
      subscribed: "Suscrito",
      notSubscribed: "No suscrito",
      subscribedCount: "{{count}}/{{total}} suscritos",
      subscribeAll: "Suscribirse a todos",
      unsubscribeAll: "Desuscribirse de todos",
      frequencies: {
        weekly: "Semanal",
        biweekly: "Quincenal",
        monthly: "Mensual"
      },
      lastUpdate: "Última actualización",
      empty: "No hay fuentes disponibles",
      emptyDescription: "Las fuentes RSS estarán disponibles pronto"
    },
    dateGroups: {
      today: "Hoy",
      yesterday: "Ayer",
      thisWeek: "Esta semana",
      thisMonth: "Este mes",
      older: "Más antiguo"
    },
    relative: {
      justNow: "Ahora mismo",
      minutesAgo: "Hace {{count}}min",
      hoursAgo: "Hace {{count}}h",
      daysAgo: "Hace {{count}}d"
    },
    specialties: {
      urgence: "Medicina de Urgencias",
      urgences: "Urgencias",
      anesthesie: "Anestesiología",
      anesthesie_reanimation: "Anestesiología y Reanimación",
      medecine_interne: "Medicina Interna",
      general: "Medicina General",
      medecine_generale: "Medicina General",
      cardiologie: "Cardiología",
      neurologie: "Neurología",
      pneumologie: "Neumología",
      gastroenterologie: "Gastroenterología",
      pediatrie: "Pediatría",
      radiologie: "Radiología"
    },
    messages: {
      subscribed: "Suscrito a la fuente",
      unsubscribed: "Desuscrito de la fuente",
      frequencyUpdated: "Frecuencia actualizada",
      allMarkedRead: "Todas las notificaciones marcadas como leídas",
      loadError: "Error al cargar datos",
      updateError: "Error al actualizar",
      loading: "Cargando..."
    }
  }
};
